import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNUser } from './cnuser';

@RegisterItem()
export class CNGroup extends CNUser {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNGroup';
    }

    public clone(): any {
        return new CNGroup();
    }
}
